package com.veldekar.components.srd.spells

import androidx.compose.runtime.Composable
import com.veldekar.components.srd.SpellComponent
import com.veldekar.components.srd.SpellMetadata

@Composable
public fun CalmEmotionsMetadata() {
    SpellMetadata(
        spellIndex = "calm-emotions",
        castingTime = "1 action",
        range = "60 feet",
        components = listOf(SpellComponent.VERBAL, SpellComponent.SOMATIC),
        material = null,
        duration = "Up to 1 minute",
        damageBase = null,
        damageScaling = null,
        savingThrow = "CHA (None)",
        aoe = "20-ft Sphere",
        concentration = true
    )
}
